import { Breadcrumb } from '@driftt/dds'
import React from 'react'

export const GuardrailsBreadcrumbs = ({
  guardrailName,
}: {
  guardrailName: string
}) => {
  return (
    <Breadcrumb.Root>
      <Breadcrumb.Link href="/playbooks/ai-guardrails">
        Guardrails
      </Breadcrumb.Link>
      <Breadcrumb.Link>{guardrailName}</Breadcrumb.Link>
    </Breadcrumb.Root>
  )
}
